import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Pagewrapper } from "../../components";
import Row from "react-bootstrap/Row";

const Colunas = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row>
        <Col>
          <h1 className="mt-5 text-center">Colunas</h1>
        </Col>
      </Row>
    </Container>
  </Pagewrapper>
);

export default Colunas;
